//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pdpComponentMixin from '~/mixins/pdpComponentMixin'

export default {
  mixins: [pdpComponentMixin],
  props: {
    part: { type: Object, required: true }
  },
  computed: {
    currentChoice () {
      const partSkuPrefix = this.part.skuPrefix
      if (partSkuPrefix in this.design) return `${partSkuPrefix}_${this.design[partSkuPrefix]}`
      if (partSkuPrefix in this.secondaryDesign) return `${partSkuPrefix}_${this.secondaryDesign[partSkuPrefix]}`
      return null
    },
    currentChoiceDetails () {
      if (!this.currentChoice) return {}
      return this.allChoices[this.currentChoice] || {}
    },
    currentChoiceName () {
      return this.stripLensTech(this.currentChoiceDetails.name)
    },

    filteredChoices () {
      return [...this.part.options].filter(
        ([sku, part]) => {
          // Filter out parts that can't be sold on their own (part.allowAlone can be unset, hence type checking false)
          if (this.pageMode === 'parts' && part.allowAlone === false) return false

          // Filter out lenses that don't match the active lens tech
          const isLensPart = this.getIsLensPart(sku)
          const isCurrentLensTech = this.getLensTech(sku) === this.lensTech
          if (this.allowLensTechFiltering && isLensPart && !isCurrentLensTech) return false
          
          return true
        }
      ).map(([sku, part]) => ({
        sku,
        ...part,
        isInStock: this.lensTechSelectedOrStatic ? this.getStockState(sku) : this.getAnyLensesInStock(sku),
        isOnPreorder: this.lensTechSelectedOrStatic ? this.getPreorderState(sku) : this.getAllLensesOnPreorder(sku),
        isIris: sku.includes('le_8IR'),
        isActive: this.choiceIsActive(sku),
        styles: this.resolveStaticURLs(part.styles)
      }))
    }
  },
  methods: {
    stripLensTech (str) {
      if (!this.allowLensTechFiltering || this.lensTechSelected || !str) return str
      return str.replace(/^[48]KO.+>(?: Polarised)? /, '')
    },
    resolveStaticURLs (styles) {
      return (styles || '').replace(/https*:\/\/.+?images/g, `${this.$config.staticAssetURL}/images`)
    },
    choiceIsActive (choice) {
      const option = choice.split('_')[1]
      return this.design[this.part.skuPrefix] === option || this.secondaryDesign[this.part.skuPrefix] === option
    }
  }
}
